import exp from "constants";
import { CustomAxiosRequestConfig } from "../../../interceptors/axios/custom-axios";
import { BaseApi } from "../../../services/base-api";
import { ENDPOINTS } from "../constant/api-constant";
import { BroadCastApiRequest, SaveBroadcastMessageRequest } from "../model/broad-cast-api-request";
import { IMessageContent, IMessageRawResponse, IPlatforms } from "../model/broad-cast-message";
import { BroadcastConfig } from "../model/extra-model";

export const getBroadcastMessageList = async (params: BroadCastApiRequest | BroadCastApiRequest[]): Promise<IMessageRawResponse> => {
    try {
        if (!Array.isArray(params)) {
            params = [params];
        }
        const responses: IMessageRawResponse[] = await Promise.all(
            params.map(async (param: BroadCastApiRequest) => {
                try {

                    const response = await BaseApi.COMMONBaseApiCon.post(ENDPOINTS.search + '?page=1&pageSize=1000', param);
                    let currentcontent = response.data.data.content as IMessageContent[];
                    if (currentcontent && currentcontent.length > 0) {
                        currentcontent = currentcontent.map((item: any) => {
                            item.criteriaType = param.criterias.additionalCriterias;
                            return item;
                        });
                    }
                    return {
                        totalPages: response.data.data.totalPages,
                        totalItems: response.data.data.totalItems,
                        content: currentcontent
                    } as IMessageRawResponse;
                } catch {
                    return { totalPages: 0, totalItems: 0 };
                }
            })
        );


        return responses.reduce((acc, curr) => {

            acc.totalPages = (acc.totalPages || 0) + (curr.totalPages || 0);
            acc.totalItems = (acc.totalItems || 0) + (curr.totalItems || 0);
            acc.content = [...(acc.content ?? []), ...(curr.content ?? [])];

            return acc;
        }, { totalPages: 0, totalItems: 0, content: [] })


    } catch (error: any) {
        throw new Error(error?.response?.data?.error?.errorMessage || error?.response?.data?.error?.errorDescription);
    }
};


export const getBroadcastMessageDetails = async (broadcastId: number): Promise<any> => {
    try {

        const response = await BaseApi.COMMONBaseApiCon.get(`${ENDPOINTS.notification}/${broadcastId}`);
        return response.data.data;

    } catch (error: any) {
        throw new Error(error?.response?.data?.error?.errorMessage || error?.response?.data?.error?.errorDescription);
    }
};

export const saveBroadcastMessage = async (params: SaveBroadcastMessageRequest): Promise<any> => {
    try {


        if (params.broadcastId) {
            await BaseApi.COMMONBaseApiCon.put(ENDPOINTS.updateMessage, params);
        } else {
            await BaseApi.COMMONBaseApiCon.post(ENDPOINTS.saveMessage, params, { requiresCSRF: true } as CustomAxiosRequestConfig);
        }
        return "Broadcast Message Saved Successfully";

    } catch (error: any) {
        throw new Error(error?.response?.data?.error?.errorMessage || error?.response?.data?.error?.errorDescription);
    }
}



export const updateBroadcastMessage = async (params: SaveBroadcastMessageRequest): Promise<any> => {
    try {

        const response = await BaseApi.COMMONBaseApiCon.put(ENDPOINTS.updateMessage, params);
        return response.data.data;

    } catch (error: any) {
        throw new Error(error?.response?.data?.error?.errorMessage || error?.response?.data?.error?.errorDescription);
    }
}

export const deleteBroadcastMessage = async (param: Object): Promise<any> => {
    try {

        const response = await BaseApi.COMMONBaseApiCon.delete(`${ENDPOINTS.deleteMessage}`, {
            data: param
        });
        return response.data.data;

    } catch (error: any) {
        throw new Error(error?.response?.data?.error?.errorMessage || error?.response?.data?.error?.errorDescription);
    }
}


export const getUserConfigByHoneywellId = async (honeywellId: string): Promise<BroadcastConfig> => {
    try {
        const response = await BaseApi.COMMONBaseApiCon.post(`${ENDPOINTS.userconfigGet}`, { honeywellId });
        return response.data.data;
    } catch (error: any) {
        throw new Error(error?.response?.data?.error?.errorMessage || error?.response?.data?.error?.errorDescription);
    }
}

export const saveUserConfig = async (hwd: string, choice: boolean, configid?: string | number): Promise<any> => {
    try {
        const response = configid ? await BaseApi.COMMONBaseApiCon.put(ENDPOINTS.userconfigSave,

            {
                "userConfigId": configid,
                "honeywellId": hwd,
                "broadcastDisableFlag": choice,
                "broadcastPopupOffset": 10
            })
            : await BaseApi.COMMONBaseApiCon.post(ENDPOINTS.userconfigSave,

                {
                    "honeywellId": hwd,
                    "broadcastDisableFlag": choice,
                    "broadcastPopupOffset": 10
                }

                , { requiresCSRF: true } as CustomAxiosRequestConfig);
        return response.data.data;
    } catch (error: any) {
        throw new Error(error?.response?.data?.error?.errorMessage || error?.response?.data?.error?.errorDescription);
    }
}